import {
  initDatadogObservability,
  isInitialized,
  ObservabilityErrorBoundary,
  logInfo,
  logError,
  addRumError,
  setUserContext,
  clearUserContext,
  getCorrelationKey,
} from "@webmotors/anunciar.tools";
import type { Config } from "../../config/config.contract";
import { ConfigFactory } from "../../config/config.factory";
import { EnvironmentType } from "../../config/config.types";
import { exposeBuildVersion, getBuildVersion } from "./build-version";

const DATADOG_SERVICE =
  process.env.NEXT_PUBLIC_DATADOG_SERVICE ?? "wm-favorites-frontend-ui";

const resolveObservabilityConfig = (): Config =>
  ConfigFactory(
    (process.env.NEXT_PUBLIC_ENVIRONMENT as EnvironmentType) ??
      EnvironmentType.LOCAL
  );

const initDatadog = (): void => {
  const config = resolveObservabilityConfig();

  if (config.enableDatadog !== true) {
    return;
  }

  if (isInitialized()) {
    return;
  }

  exposeBuildVersion();

  initDatadogObservability(
    {
      applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ?? "",
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? "",
      site: "datadoghq.com",
      service: DATADOG_SERVICE,
      env: process.env.NEXT_PUBLIC_ENVIRONMENT || "local",
      sessionSampleRate: config.sessionSampleRate,
      sessionReplaySampleRate: config.sessionReplaySampleRate,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
    },
    getBuildVersion()
  );
};

export {
  initDatadog,
  ObservabilityErrorBoundary,
  exposeBuildVersion,
  getBuildVersion,
  logInfo,
  logError,
  addRumError,
  setUserContext,
  clearUserContext,
  getCorrelationKey,
  isInitialized,
};
